module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-29-472d26a52a8127544723da41de457e12.png";